var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13271",
    "data-name": "Group 13271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2867",
    "data-name": "Rectangle 2867",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13270",
    "data-name": "Group 13270",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13112",
    "data-name": "Path 13112",
    d: "M20,19.95c0-.25-.011-.5-.029-.748a10.154,10.154,0,0,0-.268-1.739,9.336,9.336,0,0,0-5.6-6.653c-.091-.04-.181-.085-.29-.137.3-.327.614-.618.87-.951a5.762,5.762,0,0,0,.854-6.012,6.853,6.853,0,0,0-.411-.838c-.029-.05-.059-.1-.09-.149A5.972,5.972,0,0,0,10.8.044,6.186,6.186,0,0,0,7,.832a5.963,5.963,0,0,0-.96,9.636c.054.05.109.1.208.187l-.407.185c-.083.038-.166.077-.248.117a10.219,10.219,0,0,0-2.949,2.107A8.962,8.962,0,0,0,.8,15.967a10.388,10.388,0,0,0-.439,1.4c-.112.465-.162.951-.246,1.423A10.119,10.119,0,0,0,0,20c.172,0,.345,0,.517,0v0H20v-.05M6,5.988a4.012,4.012,0,1,1,8.023,0A4.012,4.012,0,1,1,6,5.988m-3.333,10.6A7.33,7.33,0,0,1,8.6,12.1a8.226,8.226,0,0,1,6.2,1.326A7.17,7.17,0,0,1,17.79,18H2.239a7.044,7.044,0,0,1,.43-1.411",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.679357f3fa340135743e2ebc5f05ddb1.svg";
export { ForwardRef as ReactComponent };